/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `USD` - US Dollar
 * * `EUR` - Euro
 * * `GBP` - British Pound
 * * `AUD` - Australian Dollar
 * * `BRL` - Brazilian Real
 * * `CAD` - Canadian Dollar
 * * `CHF` - Swiss Franc
 * * `CNY` - Chinese Yuan
 * * `CZK` - Czech Koruna
 * * `DKK` - Danish Krone
 * * `HKD` - Hong Kong Dollar
 * * `HUF` - Hungarian Forint
 * * `IDR` - Indonesian Rupiah
 * * `ILS` - Israeli Shekel
 * * `INR` - Indian Rupee
 * * `ISK` - Icelandic Krona
 * * `JPY` - Japanese Yen
 * * `KRW` - South Korean Won
 * * `MXN` - Mexican Peso
 * * `MYR` - Malaysian Ringgit
 * * `NOK` - Norwegian Krone
 * * `NZD` - New Zealand Dollar
 * * `PHP` - Philippine Peso
 * * `PLN` - Polish Zloty
 * * `RON` - Romanian Leu
 * * `SEK` - Swedish Krona
 * * `SGD` - Singapore Dollar
 * * `THB` - Thai Baht
 * * `TRY` - Turkish Lira
 * * `ZAR` - South African Rand
 * @export
 */
export const DefaultCurrencyEnum = {
    Usd: 'USD',
    Eur: 'EUR',
    Gbp: 'GBP',
    Aud: 'AUD',
    Brl: 'BRL',
    Cad: 'CAD',
    Chf: 'CHF',
    Cny: 'CNY',
    Czk: 'CZK',
    Dkk: 'DKK',
    Hkd: 'HKD',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Isk: 'ISK',
    Jpy: 'JPY',
    Krw: 'KRW',
    Mxn: 'MXN',
    Myr: 'MYR',
    Nok: 'NOK',
    Nzd: 'NZD',
    Php: 'PHP',
    Pln: 'PLN',
    Ron: 'RON',
    Sek: 'SEK',
    Sgd: 'SGD',
    Thb: 'THB',
    Try: 'TRY',
    Zar: 'ZAR'
} as const;
export type DefaultCurrencyEnum = typeof DefaultCurrencyEnum[keyof typeof DefaultCurrencyEnum];


export function instanceOfDefaultCurrencyEnum(value: any): boolean {
    for (const key in DefaultCurrencyEnum) {
        if (Object.prototype.hasOwnProperty.call(DefaultCurrencyEnum, key)) {
            if (DefaultCurrencyEnum[key as keyof typeof DefaultCurrencyEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DefaultCurrencyEnumFromJSON(json: any): DefaultCurrencyEnum {
    return DefaultCurrencyEnumFromJSONTyped(json, false);
}

export function DefaultCurrencyEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefaultCurrencyEnum {
    return json as DefaultCurrencyEnum;
}

export function DefaultCurrencyEnumToJSON(value?: DefaultCurrencyEnum | null): any {
    return value as any;
}

export function DefaultCurrencyEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DefaultCurrencyEnum {
    return value as DefaultCurrencyEnum;
}

